<template>
    <c-dialog ref="dialog" mode="slide" :title="this.purchase_order_id == 0 ? '创建线下采购单' : '编辑线下采购单'" width="100vw-300" mask-close
              @close="dialogFormEditConfirm($refs.purchaseForm, arguments)">
        <c-form ref="purchaseForm" column="3" vertical unit-width="100%">
            <c-form link-parent>
                <c-form-item label="采购单号">
                    <c-input name="purchase_code" placeholder="请输入，不填将自动生成"
                             :disabled="this.purchase_order_id > 0"></c-input>
                </c-form-item>
                <c-form-item label="采购数" required :tip="this.purchase_product_count?'请录入'+this.purchase_product_count+'个背贴码':'请输入采购数量,录入背贴码的数量必须等于采购数'">
                    <c-input name="purchase_count" v-model="purchase_product_count" type="number" decimal="0"
                             :range="[1,9999]" placeholder="请输入此次采购数量" append-text="件"></c-input>
                </c-form-item>
                <c-form-item label="货款结算方" required label-tip>
                    <template #labelTip>
                        <p>即最终的采购货款结算给谁</p>
                    </template>
                    <c-select name="payee_user_type" v-model="payeeUserType" :options="payeeUserTypeOptions" :clear="false"></c-select>
                </c-form-item>
                <c-form-item label="采购部门" required>
                    <c-select name="purchase_dept_id" v-model="purchaseDeptId" async @search="searchDepartment" :value-data="purchaseDepOptions"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_department_edit')" @click="globalDialog('departmentEdit',{})">
                            创建部门
                        </c-link>
                    </template>
                </c-form-item>
                <c-form-item label="采购人" required>
                    <c-select ref="purchaseUserSelector" name="purchase_user_id" async
                              @search="searchUser('1', arguments[0], arguments[1])"
                              :disabled="!purchaseDeptId"
                              :value-data="sysuserOptions"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_sysuser_edit')" @click="createUser(1)">
                            创建采购人
                        </c-link>
                    </template>
                </c-form-item>
                <c-form-item label="仓管部门" required tip="请选择具体的仓管所在部门">
                    <c-select name="create_dept_id" v-model="createDeptId" :options="createDeptOptions"></c-select>
                </c-form-item>
                <c-form-item label="供应商" :required="payeeUserType == 2">
                    <c-select ref="supplierSelector" name="supplier_id" v-model="supplierId" async
                              @search="searchSupplier"
                              @change="changeSupplier"
                              :value-data="supplierSelected"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_purchase_supplier_edit')" @click="globalDialog('purchaseSupplierEdit',{})">
                            创建供应商
                        </c-link>
                    </template>
                </c-form-item>
                <c-form-item label="供应商联系人" :required="payeeUserType == 2">
                    <c-select ref="supplierContactSelector" name="supplier_contact_id" v-model="supplierContactId" async
                              :disabled="this.supplierId ==0"
                              @search="searchUser('2', arguments[0], arguments[1])"
                              :value-data="supplierContactSelected"></c-select>
                    <template #handle>
                        <c-link icon v-if="auth('b_sysuser_edit')"  @click="createUser(2)">
                            创建联系人
                        </c-link>
                    </template>
                </c-form-item>
            </c-form>

            <c-title>采购商品明细</c-title>
            <c-form-item :label="false" name="product_list" colspan="3">
                <m-operate border>
                    <c-button color="main" v-if="auth('b_offline_purchase_edit')"
                              prepend-icon="tf-add" @click="addRow()" :disabled="!canAddCode">添加一行
                    </c-button>
                    <c-button color="main" v-if="auth('b_offline_purchase_edit')" :hollow="true"
                              prepend-icon="tf-import"
                              @click="excelImportAnalysis()" :disabled="!canAddCode">批量导入
                    </c-button>
<!--                    <c-button color="main" :hollow="true" v-if="auth('b_offline_purchase_edit')"
                              prepend-icon="tf-search" @click="openImeiFactoryQuery()">查询IMEI出厂信息
                    </c-button>-->
                    <c-input ref="codeInput" v-model="scanCode" placeholder="请输入/扫描背贴码" :disabled="!canAddCode" @keyup.enter.native="scanHandle">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
                    <c-button color="main" @click="scanHandle" :disabled="!canAddCode">确定</c-button>
                    <template #right>
                        <p class="m-kb-tip" v-if="auth('b_offline_purchase_edit')">快捷键：<span>Ctrl + Enter</span>添加一行；<span>Ctrl + Delete</span>删除光标所在行</p>
                    </template>
                </m-operate>
                <c-table ref="productTable" border :paging="false">
                    <c-table-column label="状态" width="65" required>
                        <template #default="{data}">
                            <span v-if="!data.id" style="color: red">待保存</span>
                            <span v-else>
                                  <span v-if="data.state == 35" style="color: brown">待退库</span>
                                  <span v-else-if="data.state == 41" style="color: red">已退库</span>
                                  <span v-else-if="data.instorage_state == 2" style="color: green">已入库</span>
                                  <span v-else>
                                     <span v-if="data.inspection_state == 2" style="color: blue">已初检</span>
                                     <span v-else style="color: red">待初检</span>
                                  </span>
                            </span>
                        </template>
                    </c-table-column>
                    <c-table-column label="背贴码" width="185" required>
                        <template #default="{data}">
                            <c-input type="hidden" name="inspection_state" v-model="data.inspection_state"></c-input>
                            <c-input name="produce_unique_code" v-model="data.produce_unique_code" maxlength="30"
                                     :disabled="!data.editable"
                                     @input="clearCodeError(data)"
                                     @enter="checkProductCode(data)"
                                     @change="checkProductCode(data)">
                                <template #appendIcon><i class="tf-scan"></i></template>
                            </c-input>
                            <div class="m-code-error-tip" v-if="data.code_error">{{data.code_error}}</div>
                        </template>
                    </c-table-column>
                    <c-table-column label="IMEI码" width="185" required>
                        <template #default="{data}">
                            <c-input name="produce_imei" v-model="data.produce_imei" maxlength="30"
                                     :disabled="!data.editable"
                                     @input="clearImeiTip(data)"
                                     @enter="checkImei(data)"
                                     @change="checkImei(data)">
                                <template #append>
                                    <a v-if="data.editable" class="m-gen-imei" :class="{'z-dis': data.imei_generating}"
                                       @click="generateImei(data)">生成</a>
                                </template>
                            </c-input>
                            <div class="m-imei-tip" v-if="data.imei_tip">{{data.imei_tip}}</div>
                        </template>
                    </c-table-column>
                    <c-table-column label="类目" width="100" required>
                        <template #default="{data}">
                            <c-select name="category_id"
                                      async @search="searchCategory"
                                      @change="changeSelect($event, data,'categoryId')"
                                      :value-data="data.productCategory"
                                      v-model="data.category_id"
                                      :disabled="!data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="品牌" width="100" required>
                        <template #default="{data}">
                            <c-select name="brand_id"
                                      async @search="searchBrand(data,arguments[0], arguments[1])"
                                      @change="changeSelect($event, data,'brandId')"
                                      :value-data="data.productBrand"
                                      v-model="data.brand_id"
                                      :disabled="!data.category_id || !data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="机型" width="180" required>
                        <template #default="{data}">
                            <c-select name="spu_model_id"
                                      async @search="searchModel(data,arguments[0], arguments[1])"
                                      @change="changeSelect($event, data,'modelId')"
                                      :value-data="data.productModel"
                                      v-model="data.spu_model_id"
                                      :disabled="!data.brand_id || !data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="内存" width="100">
                        <template #default="{data}">
                            <c-select name="memory_id"
                                      async @search="searchSpuAttribute(data,'storage', arguments[0], arguments[1])"
                                      :value-data="data.productMemory"
                                      v-model="data.memory_id"
                                      :disabled="!data.spu_model_id || !data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="颜色" width="120">
                        <template #default="{data}">
                            <c-select name="color_id"
                                      async @search="searchSpuAttribute(data,'color', arguments[0], arguments[1])"
                                      :value-data="data.productColor"
                                      v-model="data.color_id"
                                      :disabled="!data.spu_model_id || !data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="等级" width="100">
                        <template #default="{data}">
                            <c-select name="level_type"
                                      async @search="searchDicInfo('LEVEL_TYPE', arguments[0], arguments[1])"
                                      :value-data="data.productLevel"
                                      v-model="data.level_type"
                                      :disabled="!data.editable"
                                      :clear="false">
                                <template #option="{data, selected}">
                                    <select-option :name="data.name" :selected="selected"></select-option>
                                </template>
                            </c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="演示机" width="110">
                        <template #default="{data}">
                            <c-select name="is_demo" :options="yesOrNoOptions"
                                      v-model="data.is_demo"
                                      :disabled="!data.editable"
                                      :clear="false"></c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="外部订单号" width="100">
                        <template #default="{data}">
                            <c-input name="out_order_number" v-model="data.out_order_number" maxlength="30"
                                     :disabled="!data.editable"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="采购价" width="110" required>
                        <template #default="{data}">
                            <c-input name="purchase_price" v-model="data.purchase_price" type="number" decimal="2"
                                     :range="[0,999999]" placeholder="采购价" append-text="元"
                                     :disabled="!data.editable" :clear="false"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="同行价" width="110">
                        <template #default="{data}">
                            <c-input name="market_price" v-model="data.market_price" type="number" decimal="2" :range="[0,999999]"
                                     placeholder="同行价" append-text="元"
                                     :disabled="!data.editable" :clear="false"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="零售价" width="110">
                        <template #default="{data}">
                            <c-input name="retail_price" v-model="data.retail_price" type="number" decimal="2" :range="[0,999999]"
                                     placeholder="零售价" append-text="元"
                                     :disabled="!data.editable" :clear="false"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="备注" width="100">
                        <template #default="{data}">
                            <c-input name="remark" v-model="data.remark" maxlength="100"
                                     :disabled="!data.editable"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column type="button" label="操作" width="80">
                        <template #default="row">
                            <c-table-button v-if="auth('b_offline_purchase_edit') && row.data.editable == 1" icon="tf-trash" @click="removeRow(row);">删除
                            </c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
        </c-form>

        <template #button>
            <c-button v-if="purchase_state == 3" color="brown" size="dialog" @click="submitHandle(3)" :disabled="!submitAble">暂存</c-button>
            <!--待确认（暂存）单无论新建还是编辑均允许确认时导出明细，与「暂存」按钮同条件-->
            <c-button color="main" v-if="purchase_state == 3" prepend-icon="tf-export" size="dialog" @click="submitHandle(4, true)" :disabled="!submitAble">确认并导出明细</c-button>
            <c-button color="main" size="dialog" @click="submitHandle(4)" :disabled="!submitAble">确认</c-button>
        </template>
    </c-dialog>
</template>

<script>

import {mapState} from "vuex";

export default {
    name: 'offlinePurchaseEdit',
    components: {
    },
    computed: {
		...mapState(['yesOrNoOptions']),
        //创建部门下拉选项：登录人所属部门；编辑时保存的部门若不在其中则补入保证回显
        createDeptOptions() {
            if (this.savedCreateDept
                    && !this.myDeptOptions.some(item => item.value == this.savedCreateDept.value)) {
                return [this.savedCreateDept].concat(this.myDeptOptions);
            }
            return this.myDeptOptions;
        },
        //是否还允许添加背贴码
        canAddCode() {
            var productCount = 0;
            if (this.$refs.productTable){
                var product_list = this.$refs.productTable.getData();
                if (product_list && product_list.length > 0){
                    productCount = product_list.length;
                }
            }
            if (productCount >= this.purchase_product_count){
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            purchase_order_id: 0,
            editState: false,
            supplierId: 0,       //已选中的供应商ID
            supplierSelected: [],//已选中的供应商信息
            supplierContactId: 0,       //已选中的供应商ID
            supplierContactSelected: [],//已选中的供应商信息
            sysuserOptions: [],//已选中的采购员
            deleteProductList: [],
            payeeUserType:1,
            payeeUserTypeOptions:[
                {name: '采购员',value: 1,color: 'blue'},
                {name: '供应商',value: 2,color: 'gray'},
            ],
            purchaseDepOptions: [],//已选中的采购部门
            purchaseDeptId:0,    //采购部门
            myDeptOptions: [],   //登录人所属部门列表（创建部门选项）
            savedCreateDept: null,//编辑时已保存的创建部门（回显用）
            originalCreateDeptId: 0,//详情加载时的创建部门（存量数据可能为空）
            createDeptId:'',     //创建部门
            scanCode: '',        //扫码输入的背贴码
            imiePoints: 0,       //IMEI查询积分余额
            purchase_product_count:0,        //采购总数
            purchase_state:3,                //3：待确认，4：已确认
            submitAble:true                  //true=可以保存
        }
    },

    mounted() {
        //下拉框键盘操作（方向键选择、回车确认）统一在 document 监听
        document.addEventListener('keydown', this.kbKeydownHandle);
        //行内输入框回车跳转在 keyup 处理，保证输入框自身 enter 校验先执行
        document.addEventListener('keyup', this.kbKeyupHandle);
        this.kbSelect = null;
        this.kbActiveEl = null;
        this.kbActiveItem = null;
        this.kbEnterDown = false;
        this.kbCtrlEnterDown = false;
        this.kbTabAnchor = null;
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.kbKeydownHandle);
        document.removeEventListener('keyup', this.kbKeyupHandle);
    },

    methods: {
        /*************下拉框键盘操作：方向键高亮、回车确认并跳转同行下一个可编辑控件*************/
        //收集组件树内所有 c-select 实例
        collectSelects(vm, list) {
            vm.$children.forEach(child => {
                if (child.$options.name == 'cSelect') list.push(child);
                this.collectSelects(child, list);
            });
            return list;
        },

        //当前展开下拉框的 c-select 实例
        openSelect() {
            return this.collectSelects(this, []).find(item => item.listPosition !== false);
        },

        //展开下拉框中当前可见的选项 DOM（排除禁用项与“新增”项）
        kbOptionItems(select) {
            return Array.prototype.slice.call(select.$refs.list.querySelectorAll('.c-select-options-item:not([disabled]):not(.c-select-options-add), .c-select-options-custom'));
        },

        //与渲染同序的可见选项数据（异步不过滤关键字，非异步按关键字过滤，含子级递归），与 kbOptionItems 的 DOM 序一一对应
        kbVisibleOptions(select) {
            const list = [];
            const keyword = (select.searchValue || '').trim().toLowerCase();
            !function loop(items) {
                (items || []).forEach(item => {
                    if (select.asyncState || !keyword || String(item.name).toLowerCase().includes(keyword)) list.push(item);
                    loop(item.children);
                });
            }(select.optionsList);
            return list;
        },

        kbClearActive() {
            if (this.kbActiveEl) {
                this.kbActiveEl.style.background = '';
                this.kbActiveEl = null;
            }
            this.kbActiveItem = null;
        },

        kbKeydownHandle(e) {
            //输入法组合期间的回车/方向键不介入（如搜狗确认候选词）
            if (e.isComposing || e.keyCode == 229) return;
            //弹窗未打开时不响应任何快捷键（弹窗为常驻单例，document 监听一直存在）
            if (!this.$refs.dialog || !this.$refs.dialog.active) return;
            //Ctrl+Enter：快捷添加一行（组合键避开普通 Enter 的行内跳转与下拉框确认）
            if (e.key == 'Enter' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                //标记本次回车已在 keydown 处理，keyup 不再执行行内跳转
                this.kbCtrlEnterDown = true;
                this.kbAddRowHandle();
                return;
            }
            //Ctrl+Delete：快捷删除光标所在行（纯 Delete 保留输入框原生删字符行为）
            if (e.key == 'Delete' && (e.ctrlKey || e.metaKey)) {
                this.kbDeleteRowHandle(e);
                return;
            }
            //Tab 键：聚焦到下拉框时自动展开（含无搜索框、原生不可聚焦的下拉框）
            if (e.key == 'Tab') {
                this.kbTabHandle(e);
                return;
            }
            if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(e.key) == -1) return;
            const select = this.openSelect();
            if (!select) return;
            //切换下拉框后清空上一个的高亮状态
            if (this.kbSelect !== select) {
                this.kbSelect = select;
                this.kbClearActive();
            }
            const options = this.kbOptionItems(select);
            if (!options.length) return;
            e.preventDefault();
            e.stopPropagation();
            if (e.key == 'Enter') {
                //回车确认：优先用方向键高亮时记录的选项数据（避免异步重渲染导致 DOM 索引错位丢失高亮），
                //其次搜索关键字首匹配，再次空值时取首项；已有值且未高亮则保持原值收起
                let item = this.kbActiveItem;
                if (!item) {
                    const items = this.kbVisibleOptions(select);
                    if (select.searchConfig && select.searchValue.trim()) item = items[0];
                    else if (select.emptyState || !select.currentData.length) item = items[0];
                }
                this.kbClearActive();
                //走组件库自身回填链路（同 customEvent 回调）：显式写入回显对象+值并触发 change 联动，
                //不依赖 clickHandle 的“同值跳过”判断，也不依赖合成 DOM click
                if (item) {
                    if (select.multiple) {
                        select.$refs.options.clickHandle(item);
                    } else {
                        select.setValueData([item]);
                        select.changeHandle();
                    }
                }
                select.foldHandle();
                //标记本次回车已在 keydown 处理，keyup 不再重复跳转
                this.kbEnterDown = true;
                this.$nextTick(() => this.focusNextInRow(select.$el));
                return;
            }
            //方向键高亮：在可见选项 DOM 中上下移动，并同步记录对应选项数据供回车确认
            let index = this.kbActiveEl ? options.indexOf(this.kbActiveEl) : -1;
            index = e.key == 'ArrowDown' ? index + 1 : index - 1;
            index = Math.min(Math.max(index, 0), options.length - 1);
            this.kbClearActive();
            this.kbActiveEl = options[index];
            this.kbActiveEl.style.background = '#F5F5F5';
            //同步记录高亮项对应的选项数据，回车确认时直接使用，避免依赖 DOM 索引二次映射
            this.kbActiveItem = this.kbVisibleOptions(select)[index];
            this.kbActiveEl.scrollIntoView({block: 'nearest'});
        },

        //Tab 导航：下一个候选是下拉框时接管焦点并展开；普通控件仍走原生 Tab（候选集与原生可聚焦序一致）
        kbTabHandle(e) {
            const selector = 'input:not([disabled]):not([type=hidden]), textarea:not([disabled]), button:not([disabled]), .c-select:not(.z-dis)';
            const candidates = Array.prototype.slice.call(this.$el.querySelectorAll(selector))
                .filter(el => el.getClientRects().length && !(el.tagName == 'INPUT' && el.closest('.c-select')));
            if (!candidates.length) return;
            const open = this.openSelect();
            const active = document.activeElement;
            const activeSelectRoot = active && active.closest ? active.closest('.c-select') : null;
            let index = -1;
            //上次 Tab 展开的无搜索框下拉框仍开着时，以它为当前位置继续导航
            if (this.kbTabAnchor && open && open.$el === this.kbTabAnchor) {
                index = candidates.indexOf(this.kbTabAnchor);
            } else {
                this.kbTabAnchor = null;
                index = candidates.indexOf(active);
                if (index == -1 && activeSelectRoot) index = candidates.indexOf(activeSelectRoot);
            }
            const next = candidates[index + (e.shiftKey ? -1 : 1)];
            //边界或普通控件：交还浏览器原生 Tab
            if (!next || !next.classList.contains('c-select')) {
                this.kbTabAnchor = null;
                return;
            }
            e.preventDefault();
            const nextSelect = this.collectSelects(this, []).find(item => item.$el === next);
            if (!nextSelect) return;
            if (open && open !== nextSelect) open.foldHandle();
            this.kbTabAnchor = next;
            if (nextSelect.$refs.input) nextSelect.$refs.input.focus();
            else nextSelect.developHandle();
        },

        //行内输入框回车：跳转同行下一个可编辑控件（输入框自身 enter 校验已在 keyup 目标节点先触发）
        kbKeyupHandle(e) {
            if (e.isComposing || e.keyCode == 229) return;
            if (e.key != 'Enter') return;
            //Ctrl+Enter（添加一行）的回车弹起：仅消费标志，不执行行内跳转
            if (this.kbCtrlEnterDown) {
                this.kbCtrlEnterDown = false;
                return;
            }
            if (e.ctrlKey || e.metaKey) return;
            if (this.kbEnterDown) {
                this.kbEnterDown = false;
                return;
            }
            const input = e.target;
            if (!input || input.tagName != 'INPUT' || input.disabled || input.type == 'hidden') return;
            //下拉框自身搜索框的回车由 keydown 分支处理，不重复跳转
            if (input.closest('.c-select')) return;
            const row = input.closest('tr');
            if (!row || !this.$el.contains(input)) return;
            this.focusNextInRow(input);
        },

        //回车确认后跳转同行下一个可编辑控件：输入框聚焦、下拉框展开
        focusNextInRow(root) {
            const selector = 'input:not([disabled]):not([type=hidden]), .c-select:not(.z-dis)';
            let candidates = [];
            const row = root.closest('tr');
            if (row) {
                candidates = Array.prototype.slice.call(row.querySelectorAll(selector));
            } else {
                const formItem = root.closest('.c-form-item');
                const form = formItem && formItem.closest('.c-form');
                if (!form) return;
                //表单区：取同一行（offsetTop 相同）表单项内的控件为候选
                candidates = Array.prototype.slice.call(form.querySelectorAll('.c-form-item'))
                    .filter(item => item.offsetTop == formItem.offsetTop)
                    .reduce((list, item) => list.concat(Array.prototype.slice.call(item.querySelectorAll(selector))), []);
            }
            const start = candidates.indexOf(root);
            for (let i = start + 1; i < candidates.length; i++) {
                //跳过当前下拉框自身的搜索输入框
                if (root.contains(candidates[i])) continue;
                if (candidates[i].tagName == 'INPUT') {
                    candidates[i].focus();
                } else {
                    const next = this.collectSelects(this, []).find(item => item.$el === candidates[i]);
                    if (next) {
                        next.$refs.input ? next.$refs.input.focus() : next.developHandle();
                    }
                }
                return;
            }
        },

        /*************快捷键：添加一行（Ctrl+Enter）、删除行（Ctrl+Delete）*************/
        //存在其它打开状态的弹窗（删除确认框、批量导入、创建采购人等子弹窗）时返回 true，
        //避免快捷键干扰子弹窗操作或重复弹出删除确认框
        kbHasOtherOpenDialog() {
            var dialogs = document.querySelectorAll('.c-dialog');
            for (var i = 0; i < dialogs.length; i++) {
                var dialog = dialogs[i];
                if (this.$el.contains(dialog)) continue;
                //关闭中的弹窗带 an-fadeout 动画类，完全关闭的弹窗不可见，均不算打开状态
                if (!dialog.classList.contains('an-fadeout') && dialog.getClientRects().length) return true;
            }
            return false;
        },

        //Ctrl+Enter 添加一行
        kbAddRowHandle() {
            if (this.kbHasOtherOpenDialog()) return;
            //无编辑权限时“添加一行”按钮本身不显示，快捷键同样静默返回
            if (!this.auth('b_offline_purchase_edit')) return;
            if (!this.canAddCode) {
                this.$message({
                    message: this.purchase_product_count > 0 ? '采购商品明细数量已达采购数，不能再添加' : '请先填写采购数',
                    type: 'warn'
                });
                return;
            }
            this.addRow();
            this.focusNewRowFirstInput();
        },

        //Ctrl+Delete 删除光标所在行
        kbDeleteRowHandle(e) {
            if (this.kbHasOtherOpenDialog()) return;
            var active = document.activeElement;
            //定位光标所在的商品明细行（tbody 的 tr 与表格行数据顺序一一对应，排除展开行等附加行）
            var table = this.$refs.productTable;
            var tr = active && active.closest ? active.closest('tr') : null;
            var inProductRow = !!(table && tr && table.$el.contains(tr));
            if (active && active.tagName == 'INPUT' && !active.disabled && active.type != 'hidden') {
                //下拉框自身的搜索输入框（分类/品牌/机型等）：处于选项关键字编辑场景，保留原生删除字符行为
                if (active.closest('.c-select')) return;
                var hasSelection = false;
                try {
                    //number 等不支持选区 API 的输入框会抛异常或返回 null，按无选区处理
                    hasSelection = active.selectionStart != null && active.selectionStart != active.selectionEnd;
                } catch (err) {
                    hasSelection = false;
                }
                if (inProductRow) {
                    //行内输入框（背贴码、IMEI码、价格等）：选中了文本时保留原生删除选中文本；
                    //未选中仅光标定位时 Ctrl+Delete 直接删除整行（逐字符编辑用 Backspace/Delete）
                    if (hasSelection) return;
                } else {
                    //行外输入框（扫码框、采购单号、采购数等表单项）：保留原生删除字符行为，不触发删行
                    var value = active.value || '';
                    var keepNative = false;
                    try {
                        keepNative = active.selectionStart == null ? value.length > 0
                                : (hasSelection || active.selectionStart < value.length);
                    } catch (err) {
                        keepNative = true;
                    }
                    if (keepNative) return;
                }
            }
            var row = null;
            if (inProductRow) {
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                var index = Array.prototype.indexOf.call(trList, tr);
                row = index == -1 ? null : table.getRow(index);
            }
            if (!row) {
                this.$message({message: '请先将光标定位到商品明细行内，再按 Ctrl + Delete 键删除该行', type: 'warn'});
                return;
            }
            //与操作列删除按钮保持一致的删除条件
            if (!this.auth('b_offline_purchase_edit') || row.data.editable != 1) {
                this.$message({message: '当前行不允许删除', type: 'warn'});
                return;
            }
            e.preventDefault();
            //删除完成后定位光标：被删行的下一行第一个输入框（被删行为最后一行时定位到删除后的最后一行）
            this.removeRow(row, () => this.focusRowAfterDelete(index));
        },

        //新增行后聚焦该行第一个可编辑输入框（背贴码）
        focusNewRowFirstInput() {
            this.$nextTick(() => {
                var table = this.$refs.productTable;
                if (!table || !table.$el) return;
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                var tr = trList[trList.length - 1];
                if (!tr) return;
                var input = tr.querySelector('input:not([type=hidden]):not([disabled])');
                if (input) input.focus();
            });
        },

        //删除行后将光标定位到被删行的下一行第一个输入框（被删行为最后一行时定位到删除后的最后一行）
        focusRowAfterDelete(rowIndex) {
            this.$nextTick(() => {
                var table = this.$refs.productTable;
                if (!table || !table.$el) return;
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                //删除后原下一行顶到被删行原索引位置
                var tr = trList[rowIndex] || trList[trList.length - 1];
                if (!tr) return;
                var input = tr.querySelector('input:not([type=hidden]):not([disabled])');
                if (input) input.focus();
            });
        },
        //闯进用户
        createUser(client_user_type){
            var props = {
                client_user_type:client_user_type,
            };
            if (client_user_type == 1){
                props.client_department_id = this.purchaseDeptId;
                this.globalDialog('sysuserEdit', {props: props});
            }else {
                props.client_supplier_id = this.supplierId;
                this.globalDialog('sysuserEdit',{props: props});
            }
        },
        //打开弹窗
        open(data) {
            this.deleteProductList = [];
            this.scanCode = '';
            this.myDeptOptions = [];
            this.savedCreateDept = null;
            this.originalCreateDeptId = 0;
            this.createDeptId = '';
            this.loadCreateDeptOptions();
            this.loadImiePoints();
            //清空表单数据
            this.$refs.purchaseForm.clear();

            if (data && data.id) {
                this.editState = true;
                this.purchase_order_id = data.id;
                this.getPurchaseOrderDetail();
            } else {
                this.purchase_state = 3;
                this.editState = false;
                this.purchase_order_id = 0;
                //采购日期设置为 今日
                this.$refs.purchaseForm.set({
                    payee_user_type:this.payeeUserType,
                    purchase_date: new Date().format('yyyy-MM-dd')
                });
                this.$refs.productTable.setData([]);
                this.focusInput();
            }
            this.$refs.dialog.open();
        },
        /*********扫码/输入背贴码处理**********/
        scanHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            // 获取当前表格数据
            var productList = this.$refs.productTable.getData() || [];
            // 检查是否已存在
            if (productList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已添加', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 1  //1=背贴码绑定商品
                },
                loading: true,
                success: data => {
                    if (data.main_state != 1 && data.main_state != 2) {
                        this.$message({message: '当前商品主状态非【待绑定】，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$message({message: '当前背贴码已关联其他采购单，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    // 构建行数据
                    var rowData = {};
                    rowData.editable = 1;
                    rowData.code_checked = data.produce_unique_code || code;//已通过接口校验的背贴码
                    rowData.produce_unique_code = data.produce_unique_code || code;
                    rowData.produce_imei = data.produce_imei || '';
                    rowData.category_id = data.category_id || '';
                    rowData.brand_id = data.brand_id || '';
                    rowData.spu_model_id = data.spu_model_id || '';
                    rowData.memory_id = data.memory_id || '';
                    rowData.color_id = data.color_id || '';
                    rowData.level_type = data.level_type || '';
                    rowData.is_demo = data.is_demo || 2;//是否演示机（1-是 2-否）
                    rowData.out_order_number = data.out_order_number || '';
                    rowData.purchase_price = data.purchase_price || undefined;
                    rowData.market_price = data.market_price || undefined;
                    rowData.retail_price = data.retail_price || undefined;
                    rowData.inspection_state = 1;
                    rowData.remark = data.remark || '';
                    // 下拉选项回显
                    rowData.productCategory = data.category_name ? [{name: data.category_name, value: data.category_id}] : [];
                    rowData.productBrand = data.brand_name ? [{name: data.brand_name, value: data.brand_id}] : [];
                    rowData.productModel = data.spu_model_name ? [{name: data.spu_model_name, value: data.spu_model_id}] : [];
                    rowData.productMemory = data.memory_name ? [{name: data.memory_name, value: data.memory_id}] : [];
                    rowData.productColor = data.color_name ? [{name: data.color_name, value: data.color_id}] : [];
                    rowData.productLevel = data.level_name ? [{name: data.level_name, value: data.level_type}] : [];
                    this.$refs.productTable.push(rowData);
                    //扫码带出的IMEI码同步查重提示（仅提示不拦截）
                    this.checkImei(rowData);
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (code, obj, message) => {
                    this.$message({message: message || '背贴码校验失败，请检查', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return false;//已自行提示，不再触发全局弹窗
                }
            });
        },
        /*********清除行内背贴码校验错误提示**********/
        clearCodeError(rowData) {
            if (rowData.code_error) {
                this.$set(rowData, 'code_error', '');
            }
        },
        /*********行内背贴码校验（编辑时直接调用后端接口）**********/
        checkProductCode(rowData) {
            var code = (rowData.produce_unique_code || '').trim();
            if (!rowData.editable) {
                return;
            }
            //正在校验中或已校验通过且值未变化时，不重复请求
            if (rowData.code_checking || (code && rowData.code_checked === code)) {
                return;
            }
            this.$set(rowData, 'code_error', '');
            if (!code) {
                return;
            }
            //本地查重：与商品列表中其他行重复
            var productList = this.$refs.productTable.getData() || [];
            if (productList.filter(item => (item.produce_unique_code || '').trim() == code).length > 1) {
                this.$set(rowData, 'code_error', '该背贴码已存在于商品列表中');
                return;
            }
            this.$set(rowData, 'code_checking', true);
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 1  //1=背贴码绑定商品
                },
                success: data => {
                    if (data.main_state != 1 && data.main_state != 2) {
                        this.$set(rowData, 'code_error', '当前商品主状态非【待绑定】，无法添加');
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$set(rowData, 'code_error', '当前背贴码已关联其他采购单，无法添加');
                        return;
                    }
                    //校验通过，记录已校验的值，避免重复请求
                    this.$set(rowData, 'code_checked', code);
                    this.$set(rowData, 'code_error', '');
                },
                fail: (code, obj, message) => {
                    //错误显示在行内输入框下方，不再触发全局弹窗
                    this.$set(rowData, 'code_error', message || '背贴码校验失败，请检查');
                    return false;
                },
                complete: () => {
                    this.$set(rowData, 'code_checking', false);
                }
            });
        },
        /*********清除行内IMEI码提示（c-input聚焦时也会补发input事件，故仅值真实变化时才清除，避免点击输入框提示消失）**********/
        clearImeiTip(rowData) {
            if (rowData.imei_tip && (rowData.produce_imei || '').trim() !== rowData.imei_checked) {
                this.$set(rowData, 'imei_tip', '');
            }
        },
        /*********行内IMEI码查重（仅提示不拦截：列表内重复/被其他商品占用统一在输入框下方提示重新入库）**********/
        checkImei(rowData) {
            var imei = (rowData.produce_imei || '').trim();
            if (!rowData.editable) {
                return;
            }
            //已校验过且值未变化时，不重复请求
            if (rowData.imei_checking || (imei && rowData.imei_checked === imei)) {
                return;
            }
            this.$set(rowData, 'imei_tip', '');
            if (!imei) {
                return;
            }
            //本地查重：与商品列表中其他行重复，提示显示在输入框下方，不拦截入库
            var productList = this.$refs.productTable.getData() || [];
            if (productList.filter(item => (item.produce_imei || '').trim() == imei).length > 1) {
                this.$set(rowData, 'imei_checked', imei);
                this.$set(rowData, 'imei_tip', '本次为重新入库，请核对');
                return;
            }
            this.$set(rowData, 'imei_checking', true);
            this.request({
                url: '/productCode/queryByImei',
                data: {
                    produce_imei: imei,
                    produce_unique_code: (rowData.produce_unique_code || '').trim()
                },
                success: data => {
                    this.$set(rowData, 'imei_checked', imei);
                    //IMEI已被其他商品占用：后端返回提示文案（在库/重新入库），显示在输入框下方，不弹窗不拦截
                    if (data) {
                        this.$set(rowData, 'imei_tip', data);
                    }
                },
                complete: () => {
                    this.$set(rowData, 'imei_checking', false);
                }
            });
        },
        /*********背贴码输入框聚焦**********/
        focusInput() {
            this.$nextTick(() => {
                if (this.$refs.codeInput) {
                    this.$refs.codeInput.focus();
                }
            });
        },
        /*********加载当前登录人所属部门列表（创建部门选项）**********/
        loadCreateDeptOptions() {
            this.request({
                url: '/sys_user/my_department_list',
                success: data => {
                    this.myDeptOptions = (data || []).map(item => {
                        return {
                            name: item.department_name,
                            value: item.id
                        };
                    });
                    //新建时登录人只有一个部门则自动选中
                    if (!this.editState && this.myDeptOptions.length == 1) {
                        this.createDeptId = this.myDeptOptions[0].value;
                    }
                }
            });
        },
        /*********加载当前商户IMEI查询积分余额**********/
        loadImiePoints() {
            this.request({
                url: '/sys_saas/account/info',
                success: data => {
                    if (data) {
                        this.imiePoints = data.imie_points || 0;
                    }
                }
            });
        },
        /*********生成IMEI码并回填当前行**********/
        generateImei(rowData) {
            if (rowData.imei_generating) {
                return;
            }
            this.$set(rowData, 'imei_generating', true);
            this.request({
                url: '/imei/generate',
                loading: true,
                success: data => {
                    this.$set(rowData, 'produce_imei', data);
                },
                complete: () => {
                    this.$set(rowData, 'imei_generating', false);
                }
            });
        },
        /*********打开IMEI出厂信息查询弹窗**********/
        openImeiFactoryQuery() {
            this.$message({
                message: '功能开发中'
            });
            /*var refresh = () => {
                this.loadImiePoints();
            };
            this.globalDialog('imeiFactoryQueryDialog', {}, refresh, refresh);*/
        },

        /**************变更 下拉框数据******************/
        changeSelect(selectData, rowData, type) {
            if (type == 'categoryId') {
                if (selectData) {
                    rowData.productBrand = [];
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.brand_id = '';
                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'brandId') {
                if (selectData) {
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'modelId') {
                if (selectData) {
                    rowData.productMemory = [];
                    rowData.productLevel = [];
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            }
        },

        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌****************/
        searchBrand(data, keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: data.category_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(data, keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: data.category_id,
                    brand_id: data.brand_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchSpuAttribute(rowData, attribute_code, keyword, resolve) {
            this.request({
                url: '/spu/attribute/value/options',
                data: {
                    attribute_code: attribute_code,
                    model_id: rowData.spu_model_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchDicInfo(dic_type_code, keyword, resolve) {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: dic_type_code,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索【供应商】下拉框信息*****************/
        searchSupplier(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SUPPLIER',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******变更【供应商】下拉框信息*****************/
        changeSupplier() {
            //清空供应商联系人
            this.supplierContactId = 0;       //已选中的供应商ID
            this.supplierContactSelected = [];       //已选中的供应商ID
        },
        /*******搜索部门*****************/
        searchDepartment(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'DEPARTMENT',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },
        /************搜索用户*******************************/
        searchUser(user_type, keyword, resolve) {
            let paramData = {
                user_type: user_type,
                options_code: 'SYSUSER',
                keyword: keyword
            };
            if (user_type == 2 && this.supplierId && this.supplierId != 0) {
                paramData.supplier_id = this.supplierId;
            }else if (user_type == 1){
                paramData.department_id = this.purchaseDeptId;
            }
            this.request({
                url: '/system/options',
                data: paramData,
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索采购订单详情*******************/
        getPurchaseOrderDetail() {
            this.request({
                url: '/purchase/order/detail',
                data: {
                    purchase_order_id: this.purchase_order_id
                },
                loading: true,
                success: data => {
                    //采购订单基本信息
                    this.$refs.purchaseForm.set(data.detailInfo);
                    this.purchase_state = data.detailInfo.purchase_state;
                    //存在供应商
                    if (data.detailInfo.supplier_id) {
                        //处理选中供应商信息
                        this.supplierSelected = [{
                            name: data.detailInfo.supplier_name,
                            value: data.detailInfo.supplier_id
                        }];
                        //处理选中供应商联系人信息
                        this.supplierContactSelected = [{
                            name: data.detailInfo.supplier_contact_realname,
                            value: data.detailInfo.supplier_contact_id
                        }];
                    }
                    //存在采购部门
                    if (data.detailInfo.purchase_dept_id) {
                        this.purchaseDepOptions = [{
                            name: data.detailInfo.purchase_dept_name,
                            value: data.detailInfo.purchase_dept_id
                        }];
                    }
                    //存在创建部门（存量数据可能无该字段）
                    if (data.detailInfo.create_dept_id) {
                        this.originalCreateDeptId = data.detailInfo.create_dept_id;
                        this.savedCreateDept = {
                            name: data.detailInfo.create_dept_name,
                            value: data.detailInfo.create_dept_id
                        };
                    }
                    //存在采购员
                    if (data.detailInfo.purchase_user_id) {
                        this.sysuserOptions = [{
                            name: data.detailInfo.purchase_user_realname,
                            value: data.detailInfo.purchase_user_id
                        }];
                    }
                    //加载工单列表
                    var productList = data.productList || [];
                    productList.forEach(item => {
                        if (!item.is_demo) item.is_demo = 2;//存量数据无该字段，默认非演示机
                    });
                    this.$refs.productTable.setData(productList);
                }
            });
        },
        /******添加行数据*********/
        addRow() {
            var rowData = {};
            rowData.editable = 1;//允许编辑
            rowData.produce_unique_code = '';//背贴码
            rowData.produce_imei = '';//商品国际移动设备识别码(唯一)
            rowData.category_id = '';//分类ID
            rowData.brand_id = '';//品牌ID
            rowData.spu_model_id = '';//机型ID
            rowData.memory_id = '';//内存ID
            rowData.color_id = '';//颜色ID
            rowData.level_type = '';      //等级ID
            rowData.is_demo = 2;          //是否演示机（1-是 2-否）
            rowData.out_order_number = '';//外部订单号
            rowData.purchase_price = undefined;//采购单价
            rowData.market_price = undefined;//同行价（元）
            rowData.retail_price = undefined;//零售价（元）
            rowData.inspection_state = 1;//初检状态（1：待完善，2：已完善）
            rowData.remark = '';//备注
            //下拉选项回显对象初始化（与扫码添加 scanHandle 保持一致）：
            //避免值对象未初始化导致 value-data 非响应式，进而出现键盘选中后不回显/联动异常
            rowData.productCategory = [];
            rowData.productBrand = [];
            rowData.productModel = [];
            rowData.productMemory = [];
            rowData.productColor = [];
            rowData.productLevel = [];
            this.$refs.productTable.push(rowData)
        },
        /******删除行数据*********/
        removeRow(row, removedCallback) {
            if (row.data.id) {
                this.$confirm({
                    type: 'warn',
                    message: (row.data.produce_unique_code ? '是否确认删除背贴码【' + row.data.produce_unique_code + '】' : '是否确认删除选中数据行'),
                    buttonName: '确认删除',
                    resolve: () => {
                        row.remove();
                        removedCallback && removedCallback();
                    }
                });
            } else {
                row.remove();
                removedCallback && removedCallback();
            }
        },
        /******导入Excel数据**********/
        excelImportAnalysis() {
            var paramData = {};
            if (this.purchase_order_id){
                paramData.purchase_order_id = this.purchase_order_id;
            }
            this.globalDialog('excelImportAnalysis', {
                props: {
                    workType: 301
                },
                data: paramData || {}
            }, (import_data_list) => {
                if (import_data_list && import_data_list.length > 0){
                    import_data_list.forEach(item => {
                        item.editable = 1;//允许编辑
                        item.inspection_state = 1;//初检状态（1：待完善，2：已完善）
                        item.is_demo = 2;          //是否演示机（1-是 2-否）
                        item.productCategory = [{name:item.category_name,value:item.category_id}];
                        item.productBrand = [{name:item.brand_name,value:item.brand_id}];
                        item.productModel = [{name:item.spu_model_name,value:item.spu_model_id}];
                        item.productMemory = item.memory_name ? [{name:item.memory_name,value:item.memory_id}] : [];
                        item.productColor = item.color_name ? [{name:item.color_name,value:item.color_id}] : [];
                        item.productLevel = item.level_type_name ? [{name:item.level_type_name,value:item.level_type}] : [];
                        this.$refs.productTable.push(item);
                    });
                }
            });
        },
        //校验重复
        findDuplicateCode(list, field) {
            const codeMap = new Map()
            const repeatCodes = new Set()

            list.forEach(item => {
                const code = item[field]
                // 空值跳过，不参与重复校验
                if (!code) return

                if (codeMap.has(code)) {
                    repeatCodes.add(code)
                } else {
                    codeMap.set(code, true)
                }
            })
            return Array.from(repeatCodes)
        },
        /*******提交编辑数据********************/
        submitHandle(purchase_state, exportDetail) {
            //产品工单列表
            var product_list = this.$refs.productTable.getData();
            //移除已经完成初检的数据
            this.$refs.purchaseForm.submit({
                url: this.purchase_order_id == 0 ? '/offline/purchase/order/add' : '/offline/purchase/order/edit',
                rule: {
                    purchase_count: [{
                        type: 'empty',
                        message: '请输入采购数',
                    }, {
                        type: 'function',
                        fun: (value, data) => {
                            return this.purchase_state==3 || !this.canAddCode;
                        },
                        message: '“采购商品明细”总数必须与“采购数”相同'
                    }],
                    payee_user_type: '请选择货款结算方',
                    supplier_id: [{
                        type: 'empty',
                        message: '请选择供应商',
                        skip: () => {
                            return this.payeeUserType == 1;
                        }
                    }],
                    supplier_contact_id: [{
                        type: 'empty',
                        message: '请选择供应商联系人',
                        skip: () => {
                            return this.payeeUserType == 1;
                        }
                    }],
                    purchase_dept_id:'请选择采购部门',
                    create_dept_id: () => {
                        //仓管所在部门必填：空值一律拦截（存量单不再豁免）
                        if (this.createDeptId) {
                            return true;
                        }
                        //登录人无归属部门时下拉无选项，提示先维护部门，避免无意义的“请选择”
                        if (this.createDeptOptions.length == 0) {
                            return '当前登录人无归属部门，无法指定仓管所在部门，请先联系管理员维护';
                        }
                        return '请选择仓管所在部门';
                    },
                    purchase_user_id:'请选择采购人',
                    product_list: data => {
                        var flag = true;
                        let msg = '';
                        if (product_list.length == 0) {
                            msg = "请至少添加一件采购商品";
                            flag = false;
                            return msg;
                        }
                        product_list.forEach(item => {
                            if (!item.produce_unique_code || !item.produce_imei
                                    || !item.category_id || !item.brand_id || !item.spu_model_id
                                    || !item.purchase_price) {
                                msg = "请完善采购商品必填项";
                                flag = false;
                            }
                        });
                        const repeatCodes = this.findDuplicateCode(product_list, 'produce_unique_code')
                        if (repeatCodes.length > 0) {
                            // 弹窗展示重复编码
                            msg = "存在重复的背贴码："+repeatCodes.join('、');
                            flag = false;
                            return msg;
                        }
                        //IMEI码重复仅在录入时弹窗提示，不拦截提交
                        //背贴码正在校验中
                        if (product_list.some(item => item.code_checking)) {
                            return "背贴码正在校验中，请稍候";
                        }
                        //存在校验未通过的背贴码
                        if (product_list.some(item => item.code_error)) {
                            return "存在校验未通过的背贴码，请修正后重试";
                        }
                        //存在校验未通过的背贴码
                        if (purchase_state == 4 && product_list.length != this.purchase_product_count) {
                            return "采购数（"+this.purchase_product_count+"）与采购商品明细总数（"+product_list.length+"）不一致，请修正后重试";
                        }
                        if (!flag){
                            return msg;
                        }
                        return true;
                    }
                },
                dataFormatter: data => {
                    data.purchase_state = purchase_state;
                    data.purchase_order_id = this.purchase_order_id || 0;
                    data.purchase_user_id = data.purchase_user_id || 0;
                    data.supplier_id = data.supplier_id || null;
                    //统一使用界面显示的创建部门保存
                    data.create_dept_id = data.create_dept_id || null;
                    //产品列表
                    data.product_list = product_list.map(item => {
                        if(!item.market_price || item.market_price == ''){
                            item.market_price = undefined;
                        }
                        if(!item.retail_price || item.retail_price == ''){
                            item.retail_price = undefined;
                        }
                        //移除背贴码校验的辅助字段
                        delete item.code_error;
                        delete item.code_checked;
                        delete item.code_checking;
                        delete item.imei_generating;
                        //移除IMEI码查重提示的辅助字段
                        delete item.imei_tip;
                        delete item.imei_checked;
                        delete item.imei_checking;
                        return item;
                    });
                    data.purchase_count = this.purchase_product_count;
                    this.submitAble = true;
                    return data;
                },
                success: (data, res,msg) => {
                    this.submitAble = true;
                    this.$message({
                        type: 'success',
                        message:msg,
                    });
                    if (res){
                        this.purchase_order_id = res;
                    }
                    //刷新页面
                    this.$emit('resolve');
                    if (purchase_state != 3 ){
                        this.$refs.dialog.close();
                    }
                    //确认并导出明细：提交成功后按最新单号导出采购商品明细
                    if (exportDetail && this.purchase_order_id) {
                        this.exportProductDetail(this.purchase_order_id);
                    }
                }
            })
        },

        /*********导出采购商品明细（与采购详情页「导出明细」同端点同下载方式）**********/
        exportProductDetail(purchase_order_id) {
            this.request({
                url: '/purchase/order/product/export/url',
                data: {
                    purchase_order_id: purchase_order_id
                },
                loading: true,
                success: data => {
                    if (data && data.url) {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        });
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .m-kb-tip
        font-size 12px
        line-height 20px
        color #999
        span
            padding 0 5px
            margin 0 2px
            border 1px solid #ddd
            border-radius 3px
            background #fff
            color #666
            font-weight bold
            white-space nowrap

    .m-balance-text
        margin-left 10px
        color #666
        font-size 12px

    .m-code-error-tip
        margin-top 2px
        color red
        font-size 12px
        line-height 16px
        white-space normal
        word-break break-all
        overflow-wrap break-word

    .m-imei-tip
        margin-top 2px
        color #ff8800
        font-size 12px
        line-height 16px
        white-space normal
        word-break break-all
        overflow-wrap break-word

    .m-gen-imei
        padding 0 6px
        font-size 12px
        color var(--color-main)
        line-height 30px
        white-space nowrap
        cursor pointer
        &.z-dis
            color #999
            cursor not-allowed
</style>